var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Checkmark } from '@carbon/icons-react';
import { useTheme } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';
export var Component = function (p) {
    var theme = useTheme();
    return (Preact.h(Box, { sx: __assign({ borderRadius: '100px', width: '28px', height: '28px', backgroundColor: theme.palette.success.main, top: '6px', right: '6px', position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }, p.sx) },
        Preact.h(Checkmark, { size: 20, fill: "white" })));
};
